module.exports = __webpack_public_path__ + "img/mxr-m133-micro-amp.5fd1b428.jpg";